<template>
  <div>
    <div ref="point" :class="classes" :style="styles">
      <slot></slot>
    </div>
    <div v-show="slot" :style="slotStyle"></div>
  </div>
</template>
<script>
import * as constants from '../../utils/constants'
const prefixCls = `${constants.PREFIX_CLASS}affix`
function getScroll(target, top) {
  const prop = top ? 'pageYOffset' : 'pageXOffset'
  const method = top ? 'scrollTop' : 'scrollLeft'
  let ret = target[prop]
  if (typeof ret !== 'number') {
    ret = window.document.documentElement[method]
  }
  return ret
}
function getOffset(element) {
  const rect = element.getBoundingClientRect()
  const scrollTop = getScroll(window, true)
  const scrollLeft = getScroll(window)
  const docEl = window.document.body
  const clientTop = docEl.clientTop || 0
  const clientLeft = docEl.clientLeft || 0
  return {
    top: rect.top + scrollTop - clientTop,
    left: rect.left + scrollLeft - clientLeft
  }
}
export default {
  name: 'TAffix',
  props: {
    offsetTop: {
      type: Number,
      default: 0
    },
    offsetBottom: {
      type: Number,
      default: 0
    },
    offsetLeft: {
      type: Number,
      default: 0
    },
    offsetRight: {
      type: Number,
      default: 0
    },
    container: {
      type: String,
      default: ''
    },
    xAxisFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      affix: false,
      styles: {},
      slot: false,
      slotStyle: {},
      scrollContainer: null
    }
  },
  computed: {
    offsetType() {
      let type = 'top'
      if (this.offsetBottom > 0) {
        type = 'bottom'
      }
      return type
    },
    classes() {
      return [
        {
          [`${prefixCls}`]: this.affix
        }
      ]
    }
  },
  mounted() {
    this.getContainer()
    this.scrollContainer.addEventListener('scroll', this.handleScroll)
    this.scrollContainer.addEventListener('resize', this.handleScroll)
    this.$nextTick(() => {
      this.handleScroll()
    })
  },
  beforeDestroy() {
    this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    this.scrollContainer.removeEventListener('resize', this.handleScroll)
  },
  methods: {
    getContainer() {
      this.scrollContainer = this.container ? document.querySelector(this.container) : window
    },
    handleScroll() {
      const affix = this.affix
      const scrollTop = getScroll(this.scrollContainer, true)
      const scrollLeft = getScroll(this.scrollContainer)
      const elOffset = getOffset(this.$el)
      const windowHeight = this.scrollContainer.innerHeight
      const elHeight = this.$el.getElementsByTagName('div')[0].offsetHeight
      // Fixed Top
      if (
        elOffset.top - this.offsetTop < scrollTop &&
        this.offsetType === 'top'
      ) {
        this.affix = true
        this.slotStyle = {
          width: this.$refs.point.clientWidth + 'px',
          height: this.$refs.point.clientHeight + 'px'
        }
        this.slot = true
        if (this.xAxisFixed && scrollLeft) {
          this.styles.marginLeft = -scrollLeft + 'px'
        } else {
          this.styles.marginLeft = 0
        }
        this.styles.top = `${this.offsetTop}px`
        this.styles.width = `${this.$el.offsetWidth}px`
        if (this.offsetLeft) {
          this.styles.left = `${this.offsetLeft}px`
        }
        if (this.offseRight) {
          this.styles.right = `${this.offseRight}px`
        }
        this.$emit('on-change', true)
      } else if (
        elOffset.top - this.offsetTop > scrollTop &&
        this.offsetType === 'top' &&
        affix
      ) {
        this.slot = false
        this.slotStyle = {}
        this.affix = false
        this.styles = {}
        this.$emit('on-change', false)
      }
      // Fixed Bottom
      if (elOffset.top + this.offsetBottom + elHeight > scrollTop + windowHeight &&
          this.offsetType === 'bottom') {
        this.affix = true
        this.slotStyle = {
          width: this.$refs.point.clientWidth + 'px',
          height: this.$refs.point.clientHeight + 'px'
        }
        this.slot = true
        if (this.xAxisFixed && scrollLeft) {
          this.styles.marginLeft = -scrollLeft + 'px'
        } else {
          this.styles.marginLeft = 0
        }
        this.styles.bottom = `${this.offsetBottom}px`
        this.styles.width = `${this.$el.offsetWidth}px`
        if (this.offsetLeft) {
          this.styles.left = `${this.offsetLeft}px`
        }
        if (this.offseRight) {
          this.styles.right = `${this.offseRight}px`
        }
        this.$emit('on-change', true)
      } else if (
        elOffset.top + this.offsetBottom + elHeight <
          scrollTop + windowHeight &&
        this.offsetType === 'bottom' &&
        affix
      ) {
        this.affix = false
        this.slot = false
        this.slotStyle = {}
        this.styles = {}
        this.$emit('on-change', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/affix/affix.vue